<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>I Hope You Dance: A Year of Weddings Novella</title><link href="styles/default.css" rel="stylesheet" type="text/css"/>
<p class="ser1" id="pA5"><a href="#/contents#bb_1" id="aa_1"><img alt="images/img-5-1.jpg" id="AtB" src="images/img-5-1.jpg"/></a></p>
<p class="tx1" id="pz5-2"><span class="tx1a"><i>I have enjoyed reading each one of the Year of Weddings</i></span> novellas as they have released, and I was delighted to be invited to participate in the second year, especially since it allowed me to return to Kings Meadow once again.</p>
<p class="tx" id="pz5-3">And a special thanks to Ami McConnell, who championed all of the stories set in Kings Meadow.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter01.vue?74935130